// extracted by mini-css-extract-plugin
export default {"schoolLogoWrapper":"SchoolLogo_schoolLogoWrapper__peCIn","buttonsWrapper":"SchoolLogo_buttonsWrapper__Ler-q","logoWrapper":"SchoolLogo_logoWrapper__DwwdM"};